var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "import-detail"
  }, [_c('div', {
    staticClass: "header-bar"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("导入记录详情")]), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.$route.query.id) + " - " + _vm._s(_vm.$route.query.fileName))])]), _c('div', {
    staticClass: "right"
  }, [_c('a-button', {
    on: {
      "click": function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "left"
    }
  }), _vm._v(" 返回列表")], 1)], 1)]), _c('a-card', {
    staticClass: "info-card",
    attrs: {
      "bordered": false
    }
  }, [_c('a-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("导入人")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.recordInfo.operatorName || '--'))])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("导入时间")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.recordInfo.importTime || '--'))])])]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("总记录数")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.recordInfo.totalCount || 0) + "条")])])]), _c('a-col', {
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("成功记录数")]), _c('div', {
    staticClass: "value success"
  }, [_vm._v(_vm._s(_vm.recordInfo.successCount || 0) + "条")])])]), _c('a-col', {
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("失败记录数")]), _c('div', {
    staticClass: "value error"
  }, [_vm._v(_vm._s(_vm.recordInfo.failCount || 0) + "条")])])])], 1)], 1), _c('a-card', {
    staticClass: "data-card",
    attrs: {
      "title": "工资明细数据",
      "bordered": false
    }
  }, [_c('div', {
    staticClass: "search-bar",
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_c('a-radio-group', {
    attrs: {
      "button-style": "solid"
    },
    on: {
      "change": _vm.fetchData
    },
    model: {
      value: _vm.statusFilter,
      callback: function callback($$v) {
        _vm.statusFilter = $$v;
      },
      expression: "statusFilter"
    }
  }, [_c('a-radio-button', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-radio-button', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("有效")]), _c('a-radio-button', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("无效")])], 1), _c('a-input-search', {
    staticStyle: {
      "width": "300px",
      "margin-left": "20px"
    },
    attrs: {
      "placeholder": "搜索姓名、身份证号、学部..."
    },
    on: {
      "search": _vm.fetchData
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  })], 1), _c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "loading": _vm.loading,
      "pagination": _vm.pagination,
      "row-key": "id",
      "bordered": "",
      "size": "middle",
      "scroll": {
        x: 'max-content'
      }
    },
    on: {
      "change": _vm.handleTableChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(text) {
        return [_c('a-tag', {
          attrs: {
            "color": text === 1 ? 'green' : 'red'
          }
        }, [_vm._v(_vm._s(text === 1 ? '有效' : '无效'))])];
      }
    }, {
      key: "action",
      fn: function fn(record) {
        return [_c('a-popconfirm', {
          attrs: {
            "title": record.status === 1 ? '确定要设为无效吗？' : '确定要设为有效吗？'
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.toggleStatus(record);
            }
          }
        }, [_c('a', {
          class: record.status === 1 ? 'error-text' : 'success-text'
        }, [_vm._v(" " + _vm._s(record.status === 1 ? '设为无效' : '设为有效') + " ")])])];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };